import { render, staticRenderFns } from "./ReportMonthlyAverageOrders.vue?vue&type=template&id=2916b0b6"
import script from "./ReportMonthlyAverageOrders.vue?vue&type=script&lang=js"
export * from "./ReportMonthlyAverageOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports